<template>
  <!-- dashboard-content-area-start -->
  <div class="tpd-content-layout">

    <!-- dashboard-tab-area -->
    <div class="dashboader-area mb-25">
      <div class="tp-dashboard-tab">
        <h2 class="tp-dashboard-tab-title">{{ lms_website.__('Enrolled Courses') }}</h2>
        <div class="tp-dashboard-tab-list">
          <ul>
            <li>
              <a class="pointer-event" @click="courses.active_tab='in_progress'" :class="(courses.active_tab==='in_progress')?'active':''">
                {{ lms_website.__('Enrolled Courses') }} <span>({{ courses.in_progress.length }})</span>
              </a>
            </li>
            <li>
              <a class="pointer-event" @click="courses.active_tab='completed'" :class="(courses.active_tab==='completed')?'active':''">
                {{ lms_website.__('Completed') }} <span>({{ courses.completed.length }})</span>
              </a>
            </li>
            <li>
              <a class="pointer-event" @click="courses.active_tab='resources'" :class="(courses.active_tab==='resources')?'active':''">
                {{ lms_website.__('Resources') }} <span>({{ totalResources }})</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- dashboard-tab-area-end -->

    <!-- course-area-start -->
    <div class="course-area">
      <div class="row" v-if="courses.active_tab!=='resources'">
        <template v-if="activeCourses.length">
          <div v-for="course in activeCourses" :key="course.name" class="col-xl-4 col-md-6">
            <div class="tp-dashboard-course mb-25">
              <div class="tp-dashboard-course-thumb">
                <router-link :to="`/courses/view/${course.name}`">
                  <img :src="(course.image)?course.image:'/assets/lms_website/images/placeholder.jpg'" alt="">
                </router-link>
              </div>
              <div class="tp-dashboard-course-content">
                <div class="tp-dashboard-rating d-flex align-items-center gap-2">
                  <div class="course-star-rating star-rating-sm d-inline-block m-0">
                    <div class="back-stars">
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                    </div>
                    <div class="front-stars" :style="'width:'+avg_rating_width(course.avg_rating)">
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                    </div>
                  </div>
                  <span>({{ course.reviews_count }} {{ lms_website.__('Reviews') }})</span>
                </div>
                <h4 class="tp-dashboard-course-title" style="font-size:18px;">
                  <router-link :to="`/courses/view/${course.name}`"> {{ clip(course.title, 60) }}</router-link>
                </h4>
                <div class="tp-dashboard-course-meta">
                <span>
                  <span>
                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M13.9228 10.0426V2.29411C13.9228 1.51825 13.2949 0.953997 12.5252 1.01445H12.4847C11.1276 1.12529 9.07163 1.82055 7.91706 2.53596L7.80567 2.6065C7.62337 2.71733 7.30935 2.71733 7.11692 2.6065L6.9549 2.50573C5.81046 1.79033 3.75452 1.1152 2.3974 1.00437C1.62768 0.943911 0.999756 1.51827 0.999756 2.28405V10.0426C0.999756 10.6573 1.50613 11.2417 2.12393 11.3122L2.30622 11.3425C3.70386 11.5238 5.87126 12.2392 7.10685 12.9143L7.1372 12.9244C7.30937 13.0252 7.59293 13.0252 7.75498 12.9244C8.99057 12.2393 11.1681 11.5339 12.5758 11.3425L12.7885 11.3122C13.4164 11.2417 13.9228 10.6674 13.9228 10.0426Z"
                        stroke="#94928E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M7.46118 2.81787V12.4506" stroke="#94928E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                 {{ course.lesson_count }} {{ lms_website.__('Lessons') }}
                </span>
                  <span>
                  <span>
                    <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.57134 7.5C8.36239 7.5 9.81432 6.04493 9.81432 4.25C9.81432 2.45507 8.36239 1 6.57134 1C4.7803 1 3.32837 2.45507 3.32837 4.25C3.32837 6.04493 4.7803 7.5 6.57134 7.5Z" stroke="#94928E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M12.1426 14C12.1426 11.4845 9.64553 9.44995 6.57119 9.44995C3.49684 9.44995 0.999756 11.4845 0.999756 14" stroke="#94928E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                  {{ course.enrollment_count }} {{ lms_website.__('Students') }}
                </span>
                </div>
                <div class="tp-dashboard-progress hidden">
                  <div class="tp-dashboard-progress-info d-flex align-items-center justify-content-between">
                    <span>3/4</span>
                    <span>85% {{ lms_website.__('Complete') }}</span>
                  </div>
                  <div class="progress" role="progressbar" aria-label="Example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar wow fadeInLeft" data-wow-duration=".9s" data-wow-delay=".3s" data-width=" 75%"></div>
                  </div>
                </div>
                <div class="tp-dashboard-course-btn">
                  <router-link class="tpd-btn-border w-100" :to="`/courses/view/${course.name}`">{{ lms_website.__('View Course') }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="courses.loading">
          <div class="placeholder-glow col-xl-4 col-md-6">
            <span class="placeholder rounded" style="width:100%;height:420px;"></span>
          </div>
          <div class="placeholder-glow col-xl-4 col-md-6">
            <span class="placeholder rounded" style="width:100%;height:420px;"></span>
          </div>
          <div class="placeholder-glow col-xl-4 col-md-6">
            <span class="placeholder rounded" style="width:100%;height:420px;"></span>
          </div>
        </template>
        <template v-if="!activeCourses.length && !courses.loading">
          <div class="col-12">
            <div class="alert alert-warning">
              <i class="far fa-info-circle mr-1"></i> Not Courses Found
            </div>
          </div>
        </template>
      </div>
      <div class="row" v-if="courses.active_tab==='resources'">
        <div class="col-12">
          <div class="tp-dashboard-course mb-25" v-if="courses.resources?.length">
            <div class="card" :class="{'mb-2':((index+1)<courses.resources.length)}" v-for="(resource,index) in courses.resources" :key="resource.parent">
              <div class="card-header font-w-600">{{ resource.title }}</div>
              <div class="list-group list-group-flush">
                <template v-for="item in resource.resources" :key="item.name">
                  <template v-if="item.link_type==='Attach Video'">
                    <a @click="openResource(item)" class="list-group-item list-group-item-action d-flex align-items-center justify-between pointer-event">
                      <span class="text-dark"><i class="far fa-video me-1"></i> {{ item.title }}</span>
                      <i class="far fa-play text-secondary" v-if="item.attach_file"></i>
                    </a>
                  </template>
                  <template v-else-if="item.link_type==='PDF'">
                    <a @click="openResource(item)" class="list-group-item list-group-item-action d-flex align-items-center justify-between pointer-event">
                      <span class="text-dark"><i class="far fa-file-pdf me-1"></i> {{ item.title }}</span>
                      <i class="far fa-search text-secondary" v-if="item.attach_file"></i>
                    </a>
                  </template>
                  <template v-else>
                    <a :href="item.url || '#'" :target="item.url?'_blank':null" class="list-group-item list-group-item-action d-flex align-items-center justify-between">
                      <span class="text-dark"><i class="far fa-link me-1"></i> {{ item.title }}</span>
                      <i class="far fa-external-link text-secondary" v-if="item.url"></i>
                    </a>
                  </template>
                </template>
              </div>
            </div>
          </div>
          <div class="alert alert-warning" v-if="!courses.resources?.length">
            <i class="far fa-info-circle mr-1"></i> Not Resources Found
          </div>
        </div>
      </div>
    </div>
    <!-- course-area-start-end -->
    <teleport to="body">
      <div class="modal fade" id="resourceViewModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="resourceViewModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable" :class="{'modal-fullscreen':(resourceModal.full_screen),'modal-xl':(!resourceModal.full_screen)}">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="resourceViewModalLabel">{{ resourceModal.resource?.title }}</h1>
              <div class="ms-auto">
                <button type="button" class="btn btn-full-screen" @click="resourceModal.full_screen=!resourceModal.full_screen">
                  <i v-if="!resourceModal.full_screen" class="far fa-expand"></i>
                  <i v-if="resourceModal.full_screen" class="far fa-compress"></i>
                </button>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
            </div>
            <div class="modal-body">
              <template v-if="resourceModal.resource?.link_type==='Attach Video'">
                <template v-if="!isGoogleDriveLink(resourceModal.resource?.attach_file)">
                  <video controls controlsList="nodownload" style="width:100%;height:100%" v-if="resourceModal.resource?.attach_file">
                    <source :src="resourceModal.resource?.attach_file" type="audio/ogg">
                    {{ lms_website.__('Your browser does not support the video tag.') }}
                  </video>
                </template>
                <template v-if="isGoogleDriveLink(resourceModal.resource?.attach_file)">
                  <div class="google-drive-iframe">
                    <iframe v-if="resourceModal.resource?.attach_file" class="custom-iframe" :src="googleDriveLinkPreview(resourceModal.resource?.attach_file)" style="width:100%;border:0;border-radius:10px;"></iframe>
                  </div>
                </template>
              </template>
              <template v-if="resourceModal.resource?.link_type==='PDF'">
                <template v-if="!isGoogleDriveLink(resourceModal.resource?.attach_file)">
                  <div class="pdf-viewer" :class="(!resourceModal.file_loaded)?'is-loading':''">
                    <div id="PDFViewer"></div>
                  </div>
                </template>
                <template v-if="isGoogleDriveLink(resourceModal.resource?.attach_file)">
                  <div class="google-drive-iframe">
                    <iframe v-if="resourceModal.resource?.attach_file" class="custom-iframe" :src="googleDriveLinkPreview(resourceModal.resource?.attach_file)" style="width:100%;border:0;border-radius:10px;"></iframe>
                  </div>
                </template>
                <div class="alert alert-warning" v-if="!resourceModal.resource?.attach_file">{{ lms_website.__('PDF file url not found') }}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </teleport>
  </div>
  <!-- dashboard-content-area-end -->
</template>

<script>
import {authData, isLoggedIn} from "../../../utils/auth";

export default {
  name: "EnrolledCourses",
  props: {},
  setup() {
    return {
      isLoggedIn
    }
  },
  data() {
    return {
      lms_website: lms_website,
      authData: authData(),
      moment: moment,
      courses: {
        loading: true,
        active_tab: 'in_progress',
        in_progress: [],
        completed: [],
        resources: [],
      },
      resourceModal: {
        full_screen: false,
        file_loaded: false,
        resource: {}
      }
    }
  },
  computed: {
    auth() {
      if (this.authData && this.authData.is_logged_in && this.authData.user) {
        return this.authData;
      }
    },
    activeCourses() {
      return this.courses[this.courses.active_tab] || [];
    },
    totalResources() {
      let total = 0;
      if (this.courses.resources && this.courses.resources.length) {
        this.courses.resources.map(r => {
          if (r.resources) {
            r.resources.map(i => {
              total += 1;
            });
          }
        });
      }
      return total;
    }
  },
  watch: {
    '$route.query.tab'(tab) {
      this.set_tab_from_route(tab);
    }
  },
  methods: {
    get_enrolled_courses() {
      this.courses.loading = true;
      frappe.call({
        type: "GET",
        method: "lms_website.api.courses.get_enrolled_courses",
        args: {},
        callback: ({message}) => {
          NProgress.done();
          this.courses.loading = false;
          this.courses.completed = message.completed;
          this.courses.in_progress = message.in_progress;
          this.get_batch_resources();
        },
      });
    },
    get_batch_resources() {
      frappe.call({
        type: "GET",
        method: "lms_website.api.user.get_batch_resources",
        args: {},
        callback: ({message}) => {
          this.courses.resources = message;
        },
      });
    },
    openResource(resource) {
      this.resourceModal.file_loaded = false;
      this.resourceModal.resource = resource;
      console.log('resource', resource)
      const PDFViewer = $('#PDFViewer');
      $('#resourceViewModal').modal('show');
      if (resource.link_type === 'PDF') {
        PDFViewer.html('');
        setTimeout(() => {
          if ($('#PDFViewer').length)
            $.when(
                $.getScript("https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.2/pdf.js"),
                $.getScript("https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.2/pdf.worker.js")
            ).done(() => {
              window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.2/pdf.worker.js';
            }).then(() => {
              $('#PDFViewer').kendoPDFViewer({
                pdfjsProcessing: {
                  file: this.getPDFLink(resource?.attach_file)
                },
                width: "100%",
                height: window.innerHeight - 160
              });
              this.resourceModal.file_loaded = true;
            })
        }, 2000);
      } else {
        this.resourceModal.file_loaded = true;
      }
    },
    isValidUrl(str) {
      const regex = /^(http|https):\/\/[^ "]+$/;
      return regex.test(str);
    },
    getPDFLink(pdf_link) {
      if (this.isValidUrl(pdf_link)) {
        return pdf_link;
      } else {
        return lms_website.get_base_url() + pdf_link;
      }
    },
    isGoogleDriveLink(link) {
      return link && link?.includes("drive.google.com");
    },
    googleDriveLinkPreview(link) {
      return link.replace('/view', '/preview');
    },
    avg_rating_width(value) {
      if (value) {
        return `${((value / 5) * 100) + 3}%`;
      }
      return '0%';
    },
    clip(str, limit) {
      if (!str) return '';
      str = str.toString();
      if (str.length <= limit) {
        return str;
      }
      return str.substr(0, limit) + '...';
    },
    format_currency(price = 0) {
      return format_currency(price);
    },
    set_tab_from_route(tab) {
      this.courses.active_tab = ['in_progress', 'completed', 'resources'].includes(tab) ? tab : 'in_progress';
    },
  },
  mounted() {
    this.set_tab_from_route(this.$route.query.tab);
    $('#resourceViewModal').on('hidden.bs.modal', () => {
      const mediaElements = document.querySelectorAll('video, audio');
      mediaElements.forEach(function (media) {
        media.pause();
      });
      this.resourceModal.file_loaded = false;
      this.resourceModal.resource = {};
    });
    setTimeout(() => {
      this.get_enrolled_courses();
      $("[data-background]").each(function () {
        $(this).css("background-image", "url( " + $(this).attr("data-background") + "  )");
      });
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
.pdf-viewer {
  background: #eeeeee;
  min-height: calc(100vh - 180px);
  border-radius: 10px;

  &.is-loading {
    position: relative;

    iframe {
      opacity: 0;
    }

    &:before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 20;
      content: "";
    }

    &:after {
      box-shadow: 0 0 45px rgba(0, 0, 0, 0.45);
      border: 4px solid #b9bac4;
      border-top: 4px solid var(--bs-primary);
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: block;
      animation: loader-spin 0.5s linear infinite;
      -webkit-animation: loader-spin 0.5s linear infinite;
      -moz-animation: loader-spin 0.5s linear infinite;
      -o-animation: loader-spin 0.5s linear infinite;
      -ms-animation: loader-spin 0.5s linear infinite;
      position: absolute;
      z-index: 55;
      left: 50%;
      top: 50%;
      margin-top: -20px;
      margin-left: -20px;
      content: "";
    }
  }
}

.youtube-iframe, .custom-iframe {
  min-height: calc(100vh - 180px);
}

.modal-fullscreen {
  .pdf-viewer {
    min-height: calc(100vh - 50px);
  }

  .youtube-iframe, .custom-iframe {
    min-height: calc(100vh - 110px);
  }
}
</style>
